<div class='msg-container'>
  <div *ngFor="let message of messageService.messages ; let i = index">
    <app-alert [message]="message" [index]="i" class="flex-row alert" [class]="'alert alert-'+message.type">
    </app-alert>
  </div>
</div>